import React from 'react';
import { formatCampaignMoney } from '../../utils/campaignCurrency';
import { WalletBalance } from '../../services/walletService';

type Props = {
  balances: WalletBalance[];
  hasAnyBalance: boolean;
};

const WalletBalances: React.FC<Props> = ({ balances, hasAnyBalance }) => (
  <div className="earnings-dashboard__currency-groups">
    {!hasAnyBalance ? (
      <div className="analytics-card">
        <p className="analytics-empty">
          No wallet activity yet. When you add a campaign song to a playlist, your earning shows up
          here as eligible. After the campaign is completed it moves to pending, then becomes
          available to withdraw.
        </p>
      </div>
    ) : (
      balances.map(balance => (
        <section key={balance.currencyCode} className="currency-summary-card">
          <div className="currency-summary-card__header">
            <div>
              <h3>{balance.currencyCode}</h3>
            </div>
            <span className="currency-summary-card__tag">Wallet currency</span>
          </div>
          <div className="earnings-dashboard__kpis">
            <article className="kpi-card kpi-card--success">
              <h4>Available</h4>
              <p>{formatCampaignMoney(balance.available, balance.currencyCode)}</p>
              <small>Ready to withdraw or pay renewals/upgrades</small>
            </article>
            <article className="kpi-card kpi-card--primary">
              <h4>Eligible earnings</h4>
              <p>{formatCampaignMoney(balance.eligibleEarnings || 0, balance.currencyCode)}</p>
              <small>Not spendable yet — waiting for campaign complete</small>
            </article>
            <article className="kpi-card kpi-card--primary">
              <h4>Pending earnings</h4>
              <p>{formatCampaignMoney(balance.pendingEarnings, balance.currencyCode)}</p>
              <small>Not spendable yet — cooling before available</small>
            </article>
            <article className="kpi-card">
              <h4>Reserved for payout</h4>
              <p>{formatCampaignMoney(balance.reserved, balance.currencyCode)}</p>
              <small>Waiting on admin payout</small>
            </article>
          </div>
        </section>
      ))
    )}
  </div>
);

export default WalletBalances;
